import React from 'react'
import services from '../constants/services'
import "../styles/services.css"
const Services = ()=> {
  return (
    <section className='bg-grey'>
        <div className="section-title">
      <h2>Services</h2>
      <div className="underline"></div>
    </div>
    <div className='section-center services-center'>
{services.map((service) => {
    const {id,title,icon,text} = service
    return(
        <article id={id} className="service">
            {icon}
            <h4>{title}</h4>
            <div className="underline"></div>
            <p> {text} </p>  
        </article>
    )
})}
</div>
    </section>
  )
}
export default Services